export const skillsInfo = [
  [
    {
      key: 1,
      name: "HTML",
      img: "./assets/images/skillsImgs/html-5.png",
    },
    {
      key: 2,
      name: "CSS",
      img: "./assets/images/skillsImgs/css-3.png",
    },
    {
      key: 3,
      name: "JAVASCRIPT",
      img: "./assets/images/skillsImgs/js.png",
    },
    {
      key: 4,
      name: "TYPESCRIPT",
      img: "./assets/images/skillsImgs/typescript.png",
    },
    {
      key: 5,
      name: "REACT JS",
      img: "./assets/images/skillsImgs/react.png",
    },
    {
      key: 6,
      name: "NODE JS",
      img: "./assets/images/skillsImgs/node.jpg",
    }],
    [{
      key: 7,
      name: "EXPRESS",
      img: "./assets/images/skillsImgs/express.png",
    }
  ,
  
    {
    key: 8,
    name: "MONGO DB",
    img: "./assets/images/skillsImgs/mongodb.jpg",
  },
  {
    key: 9,
    name: "PYTHON",
    img: "./assets/images/skillsImgs/python.png",
  },
  {
    key: 10,
    name: "FLASK",
    img: "./assets/images/skillsImgs/flask.png",
  },
  {
    key: 11,
    name: "DJANGO",
    img: "./assets/images/skillsImgs/django.png",
  },
  {
    key: 12,
    name: "MYSQL",
    img: "./assets/images/skillsImgs/mysql.png",
  }
    ],
  [{
    key: 13,
    name: "C",
    img: "./assets/images/skillsImgs/c.png",
  },
  {
    key: 14,
    name: "C++",
    img: "./assets/images/skillsImgs/cpp.png",
  }
],
];
